import i18n from "@/i18n/i18n";

import {
  LayoutDashboard, Compass, Building2, MapPin, UserPlus,
  PackageSearch, Images, Target, Star,
  Gauge, CreditCard,
  Users, LifeBuoy, CheckSquare, ShieldCheck, ScrollText,
  Plug, Activity, HardDrive,
  KeyRound, ShieldAlert, Database, DatabaseZap,
  LineChart, Workflow, Package, Send, ListChecks,
} from "lucide-react";

// type: "module" = gated by RBAC module; "superadmin" = super_admin only.
// section = sidebar group header (rendered when it differs from the previous item).
export const NAV_ITEMS = [
  { key: "dashboard", path: "/", label: "Dashboard", icon: LayoutDashboard, type: "module", module: "dashboard", testid: "nav-link-dashboard" },

  { key: "research", path: "/research", label: "Brocki-Verzeichnis", icon: Compass, type: "module", module: "research", section: "Kunden & Brockis", testid: "nav-link-research" },
  { key: "az_master", path: "/az-master", label: "Schweiz A–Z Master", icon: Database, type: "superadmin", section: "Kunden & Brockis", testid: "nav-link-az-master" },
  { key: "kunden", path: "/brockis", label: "FUNDIO-Kunden", icon: Building2, type: "module", module: "brocki", section: "Kunden & Brockis", testid: "nav-link-fundio-kunden" },
  { key: "standorte", path: "/standorte", label: "Standorte", icon: MapPin, type: "module", module: "brocki", section: "Kunden & Brockis", testid: "nav-link-standorte" },
  { key: "onboarding", path: "/onboarding", label: "Onboarding", icon: UserPlus, type: "module", module: "onboarding", section: "Kunden & Brockis", testid: "nav-link-onboarding" },

  { key: "fundstuecke", path: "/fundstuecke", label: "Fundstücke", icon: PackageSearch, type: "module", module: "fundstuecke", section: "Inhalte", testid: "nav-link-fundstuecke" },
  { key: "medien", path: "/medien", label: "Medien & Galerie", icon: Images, type: "module", module: "brocki", section: "Inhalte", testid: "nav-link-medien" },
  { key: "anfragen", path: "/anfragen", label: "Anfragen / Leads", icon: Target, type: "module", module: "brocki", section: "Inhalte", testid: "nav-link-anfragen" },
  { key: "bewertungen", path: "/bewertungen", label: "Bewertungen", icon: Star, type: "module", module: "moderation", section: "Inhalte", testid: "nav-link-bewertungen" },

  { key: "plaene", path: "/plaene", label: "Plan & Nutzung", icon: Gauge, type: "module", module: "brocki", section: "Business", testid: "nav-link-plaene" },
  { key: "abos_rechnungen", path: "/abos-rechnungen", label: "Abos & Rechnungen", icon: CreditCard, type: "superadmin", section: "Business", testid: "nav-link-abos-rechnungen" },

  { key: "sales_dashboard", path: "/verkauf", label: "Sales Dashboard", icon: LineChart, type: "module", module: "sales", section: "Verkauf & Wachstum", testid: "nav-link-sales-dashboard" },
  { key: "sales_candidates", path: "/verkauf/kandidaten", label: "Verkaufskandidaten", icon: Target, type: "module", module: "sales", section: "Verkauf & Wachstum", testid: "nav-link-sales-candidates" },
  { key: "sales_pipeline", path: "/verkauf/pipeline", label: "Pipeline", icon: Workflow, type: "module", module: "sales", section: "Verkauf & Wachstum", testid: "nav-link-sales-pipeline" },
  { key: "sales_offers", path: "/verkauf/angebote", label: "Angebote & Pakete", icon: Package, type: "module", module: "sales", section: "Verkauf & Wachstum", testid: "nav-link-sales-offers" },
  { key: "sales_claims", path: "/verkauf/claims", label: "Claims & Onboarding", icon: Send, type: "module", module: "sales", section: "Verkauf & Wachstum", testid: "nav-link-sales-claims" },

  { key: "users", path: "/benutzer", label: "Benutzer & Rollen", icon: Users, type: "module", module: "users", section: "Admin", testid: "nav-link-benutzer" },
  { key: "support", path: "/support", label: "Support", icon: LifeBuoy, type: "superadmin", section: "Admin", testid: "nav-link-support" },
  { key: "freigaben", path: "/freigaben", label: "Freigaben", icon: CheckSquare, type: "module", module: "moderation", section: "Admin", testid: "nav-link-freigaben" },
  { key: "moderation", path: "/moderation", label: "Moderation", icon: ShieldCheck, type: "module", module: "moderation", section: "Admin", testid: "nav-link-moderation" },
  { key: "audit", path: "/audit", label: "Audit Log", icon: ScrollText, type: "module", module: "audit", section: "Admin", testid: "nav-link-audit" },

  { key: "integrations", path: "/integrationen", label: "Integrationen", icon: Plug, type: "module", module: "integrations", section: "System", testid: "nav-link-integrationen" },
  { key: "system", path: "/system", label: "Systemstatus", icon: Activity, type: "module", module: "system", section: "System", testid: "nav-link-system" },
  { key: "storage", path: "/storage", label: "Storage & Migration", icon: HardDrive, type: "module", module: "system", section: "System", testid: "nav-link-storage" },
  { key: "data_import", path: "/datenimport", label: "Datenimport", icon: DatabaseZap, type: "superadmin", section: "System", testid: "nav-link-datenimport" },
  { key: "import_ops", path: "/import-betrieb", label: "Import und Betrieb", icon: Workflow, type: "superadmin", section: "System", testid: "nav-link-import-betrieb" },
  { key: "verification", path: "/verzeichnispruefung", label: "Verzeichnisprüfung", icon: ListChecks, type: "review", section: "System", testid: "nav-link-verzeichnispruefung" },

  { key: "security_status", path: "/security-status", label: "Security Status", icon: ShieldAlert, type: "superadmin", section: "Sicherheit", testid: "nav-link-security-status" },
  { key: "mfa_recovery", path: "/mfa-recovery", label: "MFA-Recovery", icon: KeyRound, type: "superadmin", section: "Sicherheit", testid: "nav-link-mfa-recovery" },
];

const success = "bg-status-success-bg text-status-success border-status-success-border";
const warning = "bg-status-warning-bg text-status-warning border-status-warning-border";
const info = "bg-status-info-bg text-status-info border-status-info-border";
const danger = "bg-status-danger-bg text-status-danger border-status-danger-border";
const neutral = "bg-fundio-subtle text-fundio-muted border-fundio-border";

export const FUND_STATUS = {
  eingegangen: { label: "Eingegangen", cls: info },
  in_moderation: { label: "In Moderation", cls: warning },
  freigegeben: { label: "Freigegeben", cls: success },
  abgeholt: { label: "Abgeholt", cls: neutral },
};
export const BROCKI_STATUS = {
  aktiv: { label: "Aktiv", cls: success },
  wartung: { label: "Wartung", cls: warning },
  inaktiv: { label: "Inaktiv", cls: neutral },
};
export const ORG_STATUS = {
  active: { label: "Aktiv", cls: success },
  aktiv: { label: "Aktiv", cls: success },
  inactive: { label: "Inaktiv", cls: neutral },
  suspended: { label: "Gesperrt", cls: danger },
};
export const PLAN_CLS = {
  FREE: "bg-fundio-subtle text-fundio-muted border-fundio-border",
  LIGHT: "bg-status-info-bg text-status-info border-status-info-border",
  WEBPRO: "bg-fundio-gold/12 text-fundio-gold-deep border-fundio-gold/30",
  MULTI: "bg-status-success-bg text-status-success border-status-success-border",
};
export const MOD_STATUS = {
  pending: { label: "Prüfen", cls: warning },
  approved: { label: "Freigegeben", cls: success },
  rejected: { label: "Abgelehnt", cls: danger },
};
export const JOB_STATUS = {
  queued: { label: "Warteschlange", cls: neutral },
  running: { label: "Läuft", cls: info },
  done: { label: "Abgeschlossen", cls: success },
  failed: { label: "Fehlgeschlagen", cls: danger },
};
export const INTEGRATION_STATUS = {
  connected: { label: "Verbunden", cls: success },
  disconnected: { label: "Getrennt", cls: neutral },
};
export const ONBOARDING_STATUS = {
  entwurf: { label: "Entwurf", cls: neutral },
  in_pruefung: { label: "In Prüfung", cls: info },
  verifiziert: { label: "Verifiziert", cls: warning },
  freigegeben: { label: "Freigegeben", cls: success },
  abgelehnt: { label: "Abgelehnt", cls: danger },
};
export const RESEARCH_STATUS = {
  DISCOVERED: { label: "Gefunden", cls: neutral },
  REVIEW_REQUIRED: { label: "Review nötig", cls: danger },
  PARTIALLY_VERIFIED: { label: "Teilw. verifiziert", cls: warning },
  VERIFIED: { label: "Verifiziert", cls: info },
  READY_FOR_IMPORT: { label: "Importbereit", cls: success },
  REJECTED: { label: "Abgelehnt", cls: neutral },
  IMPORTED: { label: "Importiert", cls: success },
};
export const OPERATOR_TYPE = {
  independent: { label: "Unabhängig", cls: info },
  branch: { label: "Filiale", cls: warning },
  unknown: { label: "Unbekannt", cls: neutral },
};

export function formatDate(iso) {
  if (!iso) return "—";
  const lang = (i18n.language || "de").slice(0, 2);
  const loc = { de: "de-CH", fr: "fr-CH", it: "it-CH", en: "en-CH" }[lang] || "de-CH";
  try {
    return new Date(iso).toLocaleString(loc, {
      day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
